import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "font-sans p-4 pt-6" }
const _hoisted_2 = { class: "flex flex-col w-full space-y-4" }
const _hoisted_3 = { class: "flex flex-col w-full space-y-4" }

import {PropType} from 'vue';
import {ChatParticipantInterface} from "@/interfaces/ChatParticipantInterface";
import ChatParticipant from "@/components/ChatParticipant.vue";
import {modalController, useIonRouter} from "@ionic/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FlirtViewChatParticipants',
  props: {
    participants: {
        type: Object as PropType<ChatParticipantInterface[]>,
        required: true
    }
},
  setup(__props) {

const props = __props

const ionRouter = useIonRouter()

const viewProfile = async (user: ChatParticipantInterface) => {
  if (user.is_auth_user) return
  modalController.dismiss()
  ionRouter.navigate({
    name: 'FlirtUserProfile',
    params: {
      userId: user.id
    }
  }, 'forward', 'push')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.participants, (user, userIndex) => {
          return (_openBlock(), _createBlock(ChatParticipant, {
            onClick: ($event: any) => (viewProfile(user)),
            key: userIndex,
            user: user
          }, null, 8, ["onClick", "user"]))
        }), 128))
      ])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "safe-area-bottom" }, null, -1))
  ]))
}
}

})